import { ExportColumn } from "../ExportData/ExportData";
import { Employee } from "../../Employees/types/employees";
import { CompanyStore } from "../../Store/types/storeType";
// Define export columns for employees
export const exportEmployeeColumns: ExportColumn<Employee>[] = [
  { key: "id", label: "Employee ID" },
  { key: "firstName", label: "First Name" },
  { key: "lastName", label: "Last Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone Number" },
  {
    key: "role",
    label: "Role",
    formatter: (value) => (value ? value.toUpperCase() : "N/A")
  },
  {
    key: "accountStatus",
    label: "Status",
    formatter: (value) => value || "Active"
  }
];

/** ✅ Export columns configuration */
export const exportStoreColumns: ExportColumn<CompanyStore>[] = [
  { key: "id", label: "Store ID" },
  { key: "name", label: "Store Name" },
  { key: "status", label: "Status" }
];
